export default __webpack_public_path__ + "b473f5a55e742bdf087f937cf1051b53.png";